module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/261.5a7b701e.png";